module.exports = __webpack_public_path__ + "static/media/safe.a2030e51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/safe.svg
// module id = 894
// module chunks = 0